/**
 * RESPONSIBILITY: the small form for writing or changing the note on one request.
 *
 * Opens already holding the current note, so a note is edited and not retyped. Saving it
 * empty clears it - there is no separate "delete note", because an empty note and no note
 * are the same thing.
 */
import { useState } from 'react';
import type { RequestsSection } from '@app/sections';

export interface NoteEditorProps {
  c: RequestsSection;
  initial: string;
  onSave: (note: string) => Promise<unknown>;
  onCancel: () => void;
}

export function NoteEditor({ c, initial, onSave, onCancel }: NoteEditorProps) {
  const [text, setText] = useState(initial);
  const [busy, setBusy] = useState(false);

  return (
    <form
      className="rq-note-form"
      onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        try { await onSave(text); } finally { setBusy(false); }
      }}
    >
      <textarea
        value={text} rows={3} maxLength={4000} autoFocus
        aria-label={c.noteLabel} onChange={(e) => setText(e.target.value)}
      />
      <div className="rq-actions">
        <button className="btn" type="submit" disabled={busy}>{c.saveLabel}</button>
        <button className="btn btn-ghost" type="button" onClick={onCancel}>{c.cancelLabel}</button>
      </div>
    </form>
  );
}
